<template>
  <div class="custom-modal" id="livestream-archive">
    <transition name="el-fade-in" mode="out-in">
      <HolaconLottie v-if="loading == 'updateScreenLoading'" key="create-loading" />
      <div class="modal-body" v-else key="content-loading">
        <upgrade-overlay v-if="false"></upgrade-overlay>
        <div v-else-if="archives.length > 0">
          <div class="custom-grid-table-header archive-title">
            <span> {{ $t("archiveModal.fileName") }} </span>
            <span> {{ $t("archiveModal.session") }} </span>
            <span> {{ $t("archiveModal.date") }} </span>
            <span> {{ $t("archiveModal.fileSize") }} </span>
            <span></span>
          </div>
          <div class="archive-list">
            <div class="archive-item" v-for="item in archives" :key="item.id">
              <span>{{ item.fileName }}</span>
              <span>{{ $store.state.livesessions.items.find(x => x.id == item.sessionId) != null ? $store.state.livesessions.items.find(x => x.id == item.sessionId).title : ''}}</span>
              <span>{{ $moment(item.createDate).utc().format("DD MMMM YYYY, HH:mm") }}</span>
              <span>{{ item.sizeMb }} MB</span>
              <div class="archive-item-actions">
                <el-tooltip class="item" effect="dark" :content="$t('event.table.download')" placement="top">
                  <el-button size="mini" icon="fas fa-download" :loading="loading == 'downloadItem-' + item.id" @click="downloadArchiveItem(item)" circle type="primary"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.table.delete')" placement="top">
                  <el-popconfirm @confirm="deleteItem(item.id)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                    <el-button size="mini" slot="reference" :loading="loading == 'deleteItem-' + item.id" @click.stop="" circle icon="fas fa-trash" type="danger" class="m-0"></el-button>
                  </el-popconfirm>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <HolaconLottieNoData class="w-100" key="create-loading" :source="'holacon-sessions-records-lottie'" :title="$t('event.table.broadcastRecords')" @btnAdd="false" @btnRefresh="false" :buttonAdd="false" :buttonRefresh="false" :loading="loading" />
        </div>
      </div>
    </transition>
    <div class="modal-footer centered" slot="footer" v-if="loading != 'updateScreenLoading'">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("archiveModal.close") }}</el-button>
      </div>
      <div class="center-buttons" v-if="archives.length > 0">
        <el-pagination background @size-change="handleSizeChange" small @current-change="handleCurrentChange" :current-page.sync="filter.page" :page-sizes="[20, 30, 40, 50]" :page-size="filter.take" layout="total,sizes,prev, pager, next" :total="filter.total"></el-pagination>
      </div>
      <div class="right-buttons"></div>
    </div>
  </div>
</template>

<script>
const path = require("path");
import axios from "axios";
import { Message } from "element-ui";
export default {
  props: ["sessionId"],
  data() {
    return {
      axios,
      loading: false,
      timeout: null
    };
  },
  async created() {
    this.loading = "updateScreenLoading";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      if (this.sessionId != null && this.sessionId != undefined) {
        this.filter.sessionId = this.sessionId;
      } else {
        this.filter.sessionId = null;
      }
      await this.$store.dispatch("getLiveStreamArchiveList", this.filter);
      this.loading = false;
    }, 500);
  },
  methods: {
    async downloadArchiveItem(item) {
      this.loading = "downloadItem-" + item.id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await axios.post(
          "/livestream/downloadarchive",
          { id: item.id },
          {
            headers: {
              responseType: "stream"
            }
          }
        );
        if (!res.data.alert.hasError) {
          window.open(res.data.data.presignedUrl, "_blank");
        } else {
          Message.error(res.data.alert.message);
        }
        this.loading = false;
      }, 500);
    },
    deleteItem(id) {
      this.loading = "deleteItem-" + id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("deleteLiveStreamArchive", id);
        if (!res.data.alert.hasError) {
          await this.$store.dispatch("getLiveStreamArchiveList", this.filter);
        }
        this.loading = false;
      }, 500);
    },
    handleSizeChange(take) {
      this.filter.take = take;
    },
    handleCurrentChange(page) {
      this.filter.page = page;
      // var scrollpage = document.querySelector('#scroll-area');
      // scrollpage.scrollTo({ top: scrollpage.offsetTop, behavior: 'smooth' });
    }
  },
  watch: {
    filter: {
      deep: true,
      async handler() {
        if (this.timeout != null) clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
          await this.$store.dispatch("getLiveStreamArchiveList", this.filter);
        }, 500);
      }
    }
  },
  computed: {
    eventPermissions() {
      return this.$store.getters.getEventPermission;
    },
    filter() {
      return this.$store.getters.getLiveStreamArchiveFilter;
    },
    archives() {
      return this.$store.getters.getLiveStreamArchiveList;
    }
  }
};
</script>

<style scoped lang="less">
#livestream-archive {
  .modal-body {
    .archive-title {
      grid-template-columns: 1fr 150px 150px 100px 65px !important;
    }
    .archive-list {
      display: flex;
      flex-direction: column;
      .archive-item {
        transition: all 0.5s;
        border-radius: 8px;
        display: grid;
        background-color: #f1f1f1;
        margin-bottom: 10px;
        grid-template-columns: 1fr 150px 150px 100px 65px;
        padding: 10px;
        gap: 0.5rem;
        align-items: center;

        &:last-child {
          margin-bottom: unset;
        }
        &.passive {
          background-color: #fff2f2 !important;
        }
        .archive-item-actions {
          display: flex;
          justify-content: flex-end;
          gap: 5px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/live-stream/archiveModal.vue